import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-drag',
  templateUrl: './drag.component.html',
  styles: []
})
export class DragComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
